import { BoxProps, ColorOptions, convertHexToRGBA, TextProps } from '@jfs/ui-new'
import { Colors } from '../../util/util'

export const sectionStyles = (visible: any, section: any) => {
  const isSelected = visible === section
  return {
    sectionBox: {
      justify: 'center',
      paddingLeft: 24,
      pv: 16,
      underlayColor: 'TRANSPARENT',
      backgroundColor: isSelected
        ? (convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions)
        : ('TRANSPARENT' as ColorOptions),
      borderRightWidth: isSelected ? 2 : 0,
      borderRightColor: 'PRIMARY',
    } as BoxProps,
    sectionText: {
      color: isSelected ? 'PRIMARY' : 'BLACK',
      fontFamily: isSelected ? 'JioType-Bold' : 'JioType-Medium',
      fontSize: 14,
      lineHeight: 20,
      letterSpacing: -0.07,
    } as TextProps,
  }
}

export const styles = {
  container: {
    borderTopLeftRadius: 32,
    borderTopRightRadius: 32,
    backgroundColor: 'WHITE',
  } as BoxProps,
  closeBox: {
    underlayColor: 'LIGHTEST_GREY',
    flexDirection: 'row',
    justify: 'space-between',
    align: 'center',
    borderBottomWidth: 1,
    borderBottomColor: 'DISABLED_GREY',
    p: 24,
  } as BoxProps,
  filterItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: 'GREYISH_WHITE',
  } as BoxProps,
  filterItem: {
    flexDirection: 'row',
    alignItems: 'center',
    pv: 16,
    ph: 24,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  inputContainer: {
    width: '100%',
    paddingHorizontal: 24,
    pv: 16,
  } as BoxProps,
  buttonCon: {
    justifyContent: 'space-around',
    position: 'relative',
    p: 24,
    borderTopWidth: 1,
    borderTopColor: 'DISABLED_GREY',
    flexDirection: 'row',
  } as BoxProps,
  line: {
    borderBottomWidth: 1,
    width: '100%',
    opacity: 0.1,
    marginTop: '10%',
  } as BoxProps,
}
